export default {"src":"/_next/static/media/prompts.fefe5802.svg","height":846,"width":912,"blurWidth":0,"blurHeight":0};